document.addEventListener('DOMContentLoaded', function () {
    // Handle all version history links (from main page and sidepanel)
    const versionLinks = document.querySelectorAll('a.version-history-link');

    versionLinks.forEach(function (versionLink) {
        versionLink.addEventListener('click', function (e) {
            e.preventDefault();

            // Find the tab trigger button (desktop)
            const tabTrigger = document.querySelector('#tab-version-history');

            if (tabTrigger) {
                // Use Bootstrap 5 Tab API to show the tab
                const tab = new bootstrap.Tab(tabTrigger);
                tab.show();
            }

            // For mobile dropdown, also trigger the mobile tab button
            const mobileTabTrigger = document.querySelector('.dropdown-item[data-bs-target="#version_history_tab"]');
            if (mobileTabTrigger) {
                const mobileTab = new bootstrap.Tab(mobileTabTrigger);
                mobileTab.show();
            }
        });
    });
});
